import React from 'react';

import styles from './Checkbox.module.scss';

export interface ICheckboxProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {}

export const Checkbox = ({ checked }: ICheckboxProps) => {

    const eventHandler = (e: React.MouseEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div className={styles.checkboxWrapper}>
            <label>
                <input type="checkbox" checked={checked} onClick={eventHandler} readOnly />
                <span className={styles.checkmark} />
            </label>
        </div>
    );
};
